/**
 * Recruitment workflow §6.3 / §6.4 — the invite token kept for apply attribution.
 *
 * The invite page stores the token (per job) when it shows a live invite; the job page's apply
 * (step 5d) sends it as `invite_token` and clears it after a successful apply. sessionStorage
 * only — no cookie — so it lives for the browser tab and is never sent anywhere on its own.
 * Every access is wrapped: storage can be unavailable (private mode, blocked site data), and
 * attribution is best-effort — apply must work without it.
 */
const KEY_PREFIX = 'qh_invite_token:';

export function rememberInviteToken(jobId: string, token: string): void {
  try {
    window.sessionStorage.setItem(KEY_PREFIX + jobId, token);
  } catch {
    // Storage unavailable — the apply simply won't be attributed to the invite.
  }
}

export function readInviteToken(jobId: string): string | null {
  try {
    return window.sessionStorage.getItem(KEY_PREFIX + jobId);
  } catch {
    return null;
  }
}

export function forgetInviteToken(jobId: string): void {
  try {
    window.sessionStorage.removeItem(KEY_PREFIX + jobId);
  } catch {
    // Nothing to clear.
  }
}
